'use strict';

var $ = require('jquery');
var globalisation = require('../../utilities/globalisation');
var config = require('../config');

exports.noDuplicate = function(value, element) {
  if ($(element).hasClass(config.classes.hasDuplicate)) {
    // return false because it has a duplicate and is not valid
    return false;
  } else {
    // return true if it does not have the class
    return true;
  }
};

$.validator.addMethod('no-duplicate', exports.noDuplicate, globalisation.pluraliseAndTranslate('formValidation', 'noDuplicate', '{0}'));



// WEBPACK FOOTER //
// ./assets/js/validators/no-duplicate.js